// export const ADD_TO_CART = 'ADD_TO_CART'
// export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST'
// export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
// export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE'
// export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS'

export const CLEAR_VUEX = 'CLEAR_VUEX'

export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE'

export const RECEIVE_BANNERS = 'RECEIVE_BANNERS' // 获取首页轮播
export const RECEIVE_DYNAMIC = 'RECEIVE_DYNAMIC'
export const ADD_TO_DYNAMIC = 'ADD_TO_DYNAMIC'

export const DYNAMIC_FOOD_TYPE = 1 // 今日伙食类型
export const DYNAMIC_CURCHE_TYPE = 0 // 园点动态

// 学生
export const ADD_TO_STUDENTS = 'ADD_TO_STUDENTS'
export const RECEIVE_STUDENTS = 'RECEIVE_STUDENTS'
export const RECEIVE_STUDENTS_AND_PARENTS = 'RECEIVE_STUDENTS_AND_PARENTS'
export const CLEAR_STUDENTS = 'CLEAR_STUDENTS'
export const DELETE_STUDENT = 'DELETE_STUDENT'
export const CLEAR_STUDENT_PARENTS = 'CLEAR_STUDENT_PARENTS'

// 群组
export const ADD_TO_CLASS = 'ADD_TO_CLASS'
export const RECEIVE_CLASS = 'RECEIVE_CLASS'
export const CLEAR_CLASS = 'CLEAR_CLASS'
export const DELETE_CLASS = 'DELETE_CLASS'
export const TEACHER_CLASS = 'TEACHER_CLASS'

// 老师
export const ADD_TO_TEACHERS = 'ADD_TO_TEACHERS'
export const RECEIVE_TEACHERS = 'RECEIVE_TEACHERS'
export const CLEAR_TEACHERS = 'CLEAR_TEACHERS'
export const DELETE_TEACHER = 'DELETE_TEACHER'

// 园点
export const RECEIVE_CURCHE = 'RECEIVE_CURCHE'
export const CLEAR_CURCHE = 'CLEAR_CURCHE'

// 用户中心 -- 我的
export const RECEIVE_FAV = 'RECEIVE_FAV'
export const RECEIVE_MINE = 'RECEIVE_MINE'
export const CLEAR_FAV = 'CLEAR_FAV'
export const CLEAR_MINE = 'CLEAR_MINE'

// 作业
export const RECEIVE_HOMEWORK_LIST = 'RECEIVE_HOMEWORK_LIST'
export const RECEIVE_STUDENT_HOMEWORK_LIST = 'RECEIVE_STUDENT_HOMEWORK_LIST'
export const ADD_TO_HOMEWORK_LIST = 'ADD_TO_HOMEWORK_LIST'
export const CLEAR_HOMEWORK = 'CLEAR_HOMEWORK'
export const CLEAR_STUDENT_HOMEWORK = 'CLEAR_STUDENT_HOMEWORK'
export const DELETE_HOMEWORK = 'DELETE_HOMEWORK'
export const UPDATE_HOMEWORK_RED = 'UPDATE_HOMEWORK_RED'
export const UPDATE_HOMEWORK_STATE = 'UPDATE_HOMEWORK_STATE'

// 活动
export const RECEIVE_EVENTS_ALL = 'RECEIVE_EVENTS_ALL'
export const RECEIVE_EVENTS_MY = 'RECEIVE_EVENTS_MY'
export const CLEAR_EVENTS_ALL = 'CLEAR_EVENTS_ALL'

// 托管学院
export const RECEIVE_TOPINFO = 'RECEIVE_TOPINFOS'



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/mutation-types.js